export default __webpack_public_path__ + "static/eup-img-2-a46e0eb815fe550699a8af594057089c.png";